import React from 'react';

function Platform(props) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="38.011" height="38.011" viewBox="0 0 38.011 38.011"><path d="M38.011,30.644V0H0V30.644H14.107l-1.9,5.14H7.944v2.227H30.067V35.783h-4.26l-1.9-5.14ZM35.784,2.227V23.962H2.227V2.227ZM2.227,26.189H35.784v2.227H2.227Zm21.2,9.594H14.579l1.9-5.14h5.046Z" transform="translate(0)" fill="#4d4332"/><path d="M476.7,750.984a7.829,7.829,0,0,1,6.539,9.376H481.12a5.768,5.768,0,0,0-4.416-7.288v5.44l-2.11,1.06v-6.522a5.768,5.768,0,0,0-4.531,7.309h-2.123a7.829,7.829,0,0,1,6.655-9.392v-.982l2.11-1.06Z" transform="translate(-456.152 -740.758)" fill="#4d4332" fill-rule="evenodd"/></svg>    );
}


export default Platform;
